import { render, staticRenderFns } from "./OutputDialogSplit.vue?vue&type=template&id=019f77e2&scoped=true&"
import script from "./OutputDialogSplit.vue?vue&type=script&lang=js&"
export * from "./OutputDialogSplit.vue?vue&type=script&lang=js&"
import style0 from "./OutputDialogSplit.vue?vue&type=style&index=0&id=019f77e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019f77e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VDialog,
  VDivider,
  VSpacer,
})
